import script from "./LanguageSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelect.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelect.vue?vue&type=style&index=0&id=fbdede86&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbdede86"]])

export default __exports__